/**
 * Creates an event listener that will react to the first event
 * and after that, only every `limit` milliseconds.
 * The function was made to throttle default cancellable events.
 * See js/main.site.js for how this function is used.
 *
 * @param limit throttling amount in milliseconds
 * @returns {function(*): void} throttled default event listener
 */
window.throttledDefaultListener = (limit) => {
    let waiting = false;
    return (event) => {
        if (waiting) {
            event.preventDefault();
        } else {
            waiting = true;
            setTimeout(() => {
                waiting = false;
            }, limit);
        }
    };
};

window.clickAndDisable = (link) => {
    // Disable subsequent clicks
    link.onclick = (event) => {
        event.preventDefault();
        setTimeout(() => {
            link.onclick = () => {};
        }, 2500);
    };
};

window.openInNewTab = (url) => {
    window.open(url, '_blank').focus();
};

window.getUrlParameterByName = (unescapedName) => {
    // TODO: comment
    const name = unescapedName.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
    const results = regex.exec(window.location.search);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

window.csrftoken = () => Cookies.get('csrftoken');

window.addNext = (id) => {
    // TODO: comment
    const href = document.getElementById(id).getAttribute('href');

    document.getElementById(id).setAttribute('href', `${href}?next=${window.location.pathname}`);
};
